import { useEffect } from "react"
import { sendSpentTime } from "../api/methods/sendUserAction/handlers"
import { TIME_SPENT_PERIOD } from "../constants"
import { useTimer } from "../hooks/useTimer"
import { useAppSelector } from "../store"

/**
 * Отправляет время на сайте каждые TIME_SPENT_PERIOD секунд.
 * Вынесен в отдельный лист: useTimer обновляет стейт каждую секунду, и в корне App
 * это перерисовывало Routes и всех потребителей RouteContext (useNavigate/useSearchParams).
 */
export function SpentTimeTracker() {
  const clickId = useAppSelector(state => state.userData.clickID)
  const { totalTime } = useTimer()

  useEffect(() => {
    if (clickId && totalTime > 0 && totalTime % TIME_SPENT_PERIOD === 0) {
      sendSpentTime(clickId, totalTime)
    }
  }, [totalTime, clickId])

  return null
}
